import api from '@/api'

const store = {
  state: {
    data: [],
    one: {},
    pagingReview: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingReview: {
      byField: '',
      isDesc: false
    },
    filteringReview: {
      outletCode: null,
      formThreshold: null,
      title: null,
      question: null,
      status: null,
      googleReviewLink: null
    },
    userReviewsData: [],
    pagingUserReview: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingUserReview: {
      byField: 'createdAt',
      isDesc: false
    },
    filteringUserReview: {
      outletCode: null,
      rate: null,
      contactName: null,
      contactPhone: null,
      userChoose: null,
      review: null
    }
  },

  mutations: {
    SET_DATA: (state, payload) => {
      state.data = payload
    },
    SET_PAGING_PAGE: (state, payload) => {
      state.pagingReview.page = payload
    },
    SET_PAGING_TOTAL: (state, payload) => {
      state.pagingReview.total = payload
    },
    SET_FILTERING_REVIEW: (state, payload) => {
      state.filteringReview = payload
    },
    SET_SORTING_REVIEW: (state, payload) => {
      state.sortingReview = payload
    },
    SET_USER_REVIEW_DATA: (state, payload) => {
      state.userReviewsData = payload
    },
    SET_USER_REVIEW_PAGING_PAGE: (state, payload) => {
      state.pagingUserReview.page = payload
    },
    SET_USER_REVIEW_PAGING_TOTAL: (state, payload) => {
      state.pagingUserReview.total = payload
    },
    SET_USER_REVIEW_FILTERING_REVIEW: (state, payload) => {
      state.filteringUserReview = payload
    },
    SET_USER_REVIEW_SORTING_REVIEW: (state, payload) => {
      state.sortingUserReview = payload
    }
  },

  getters: {
    SortingReview: state => state.sortingReview,
    FilteringReview: state => state.filteringReview,
    PagingReview: state => state.pagingReview,
    GetAllReview: state => state.data,
    GetOneReview: state => id => state.data.find(data => data.id === id),
    SortingUserReview: state => state.sortingUserReview,
    FilteringUserReview: state => state.filteringUserReview,
    PagingUserReview: state => state.pagingUserReview,
    GetAllUserReviews: state => state.userReviewsData
  },

  actions: {
    async UpdateFilteringReview({ state, commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          formThreshold: null,
          title: null,
          question: null,
          status: null,
          googleReviewLink: null,
          outletCode: null
        }
        commit('SET_FILTERING_REVIEW', {
          ...state.filteringReview,
          ...emptyFilter
        })
      }
      commit('SET_PAGING_PAGE', 1)
      dispatch('GetAllReview', isResetField.uid)
    },

    async UpdateSortingReview({ commit, dispatch }, payload) {
      commit('SET_SORTING_REVIEW', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllReview', payload.uid)
    },

    async GetAllReview({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllReviewItem(
          state.pagingReview,
          state.sortingReview,
          state.filteringReview
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL', result.headers['data-length'])
        commit('SET_DATA', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateReview({ dispatch }, payload) {
      try {
        const { data } = await api.CreateReview(payload)
        dispatch('GetAllReview')
        return data
      } catch (e) {
        return (e as any).response
      }
    },

    async UpdateReview({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateReview(payload.id, payload)
        dispatch('GetAllReview')
        return data
      } catch (e) {
        return (e as any).response
      }
    },

    async DeleteReview({ dispatch }, id) {
      try {
        const { data } = await api.DeleteReview(id)
        dispatch('GetAllReview')
        return data
      } catch (e) {
        return (e as any).response
      }
    },
    async UpdateFilteringUserReviews(
      { state, commit, dispatch },
      isResetField
    ) {
      if (isResetField) {
        const emptyFilter = {
          outletCode: null,
          rate: null,
          contactName: null,
          contactPhone: null,
          userChoose: null,
          review: null
        }
        commit('SET_USER_REVIEW_FILTERING_REVIEW', {
          ...state.filteringUserReview,
          ...emptyFilter
        })
      }
      commit('SET_USER_REVIEW_PAGING_PAGE', 1)
      dispatch('GetAllUserReviews', isResetField.uid)
    },

    async UpdateSortingUserReviews({ commit, dispatch }, payload) {
      commit('SET_USER_REVIEW_SORTING_REVIEW', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllUserReviews', payload.uid)
    },

    async GetAllUserReviews({ commit, state }) {
      commit('SET_IS_FETCHING_DATA', true)
      try {
        const result = await api.GetReviewsFromUsers(
          state.pagingUserReview,
          state.sortingUserReview,
          state.filteringUserReview
        )
        commit('SET_USER_REVIEW_PAGING_TOTAL', result.headers['data-length'])
        commit('SET_USER_REVIEW_DATA', result.data.data)
        commit('SET_IS_FETCHING_DATA', false)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    }

    /**
     * The following methods are methods for requesting new interfaces
     */
  }
}

export default store
